import { withStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { IconButton, Modal, Popover, Table } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { bindActionCreators } from 'redux';
import { getShops, getShopDetail, downloadQrCode } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import ShopTableBodyGroup from '../../components/molecules/ShopTableBodyGroup';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import ShopTableHeadGroup from '../../components/molecules/ShopTableHeadGroup';
import DownloadShopCsvButton from '../../components/atoms/DownloadShopCsvButton';
import AddShopButton from '../../components/atoms/AddShopButton';
import ShopDetailGroup from './ShopDetailGroup';
import ShopEditGroup from './ShopEditGroup';
import { getOptionCities } from '../../actions/Cities';
import ShopAddGroup from './ShopAddGroup';
import BulkEditShopStatusButton from '../../components/atoms/BulkEditShopStatusButton';
import {
  editGroupShopStatus,
  editGroupGochiKidFlagShop,
  EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS,
  EDIT_GROUP_SHOP_STATUS_SUCCESS
} from '../../actions/Groups';
import BulkEditShopStatusModal from '../../components/molecules/BulkEditShopStatusModal';
import GochiKidFlagEditShopButton from '../../components/atoms/GochiKidFlagEditShopButton';
import GochiKidFlagEditShopModal from '../../components/molecules/GochiKidFlagEditShopModal';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';
import shopApplyType from '../../constants/GochiKidConstant';

const propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = {
  root: {
    display: 'flex'
  },
  shopTable: {
    borderCollapse: 'collapse',
    position: 'relative',
    overflowX: 'auto'
  },
  buttonContainer: {
    marginBottom: 5,
    display: 'flex',
    alignItems: 'flex-start'
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'end'
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  buttonInfo: {
    backgroundColor: 'transparent',
    margin: '5px 10px 5px 4px',
    padding: '6px 0'
  },
  popoverContent: {
    marginTop: 5,
    pointerEvents: 'auto'
  },
  contentPopover: {
    padding: 16,
    fontSize: 14,
    width: 377
  }
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset,
      accessibleShops: state.shops.accessibleShops,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getShops,
          getShopDetail,
          downloadQrCode,
          getOptionCities,
          editGroupShopStatus,
          editGroupGochiKidFlagShop,
          getBankList,
          getBankBranchList
        },
        dispatch
      )
    })
  ),
  // state => ({}),
  // dispatch => ({})
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('groupName', 'setGroupName', ''),
  withState('groupDepositManage', 'setGroupDepositManage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('resultMessage', 'setResultMessage', ''),
  withState('targetColumn', 'setTargetColumn', ''),
  withState('openTable', 'updateOpenTable', false),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('cityName', 'setCityName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tags', 'setTags', []),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', []),
  withState('shopAnniversaries', 'setShopAnniversaries', []),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stealthMode', 'setStealthMode', ''),
  withState('stealthModeStr', 'setStealthModeStr', ''),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('shopDetail', 'setShopDetail', {}),
  withState('isShopCanEditSetting', 'setIsShopCanEditSetting', false),
  withState('gochiRestriction', 'setGochiRestriction', ''),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('inviteUserId', 'setInviteUserId', 0),
  withState('inviteUserStr', 'setInviteUserStr', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('accountStatus', 'setAccountStatus', 1),
  withState('statusShop', 'setStatusShop', 'AVAILABLE'),
  withState('message', 'setMessage', ''),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('sortServer', 'setSortServer', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('cityId', 'setCityId', ''),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('bulkEditStatusCheckedAll', 'setBulkEditStatusCheckedAll', false),
  withState('bulkEditStatusCheckedList', 'setBulkEditStatusCheckedList', []),
  withState('openBulkEditStatusModal', 'updateOpenBulkEditStatusModal', false),
  withState('bankCode', 'setBankCode', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState(
    'editGochiKidFlagCheckedAll',
    'setEditGochiKidFlagCheckedAll',
    false
  ),
  withState(
    'gochiKidFlagEditCheckedList',
    'setGochiKidFlagEditCheckedList',
    []
  ),
  withState(
    'openGochiKidFlagEditModal',
    'updateOpenGochiKidFlagEditModal',
    false
  ),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withState('allowGapPayment', 'setAllowGapPayment', 0),
  withState('anchorEl', 'setAnchorEl', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    openDetailModal,
    updateOpenDetailModal,
    openEditModal,
    updateOpenEditModal,
    filterParams,
    page,
    onChangePage,
    shops,
    progress,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    groupDepositManage,
    setGroupDepositManage,
    shopId,
    setShopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    // cityName,
    // setCityName,
    // cityId,
    // setCityId,
    address,
    setAddress,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tags,
    setTags,
    tagStr,
    setTagStr,
    images,
    setImages,
    shopAnniversaries,
    setShopAnniversaries,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    inviteUserId,
    setInviteUserId,
    inviteUserStr,
    setInviteUserStr,
    cognitoUserId,
    setCognitoUserId,
    email,
    setEmail,
    bankSwitchable,
    setBankSwitchable,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    showPhone,
    setShowPhone,
    childShopFlag,
    setChildShopFlag,
    accountStatus,
    setAccountStatus,
    paymentGroupType,
    setPaymentGroupType,
    address1,
    setAddress1,
    address2,
    setAddress2,
    roles,
    openEditConfirm,
    updateOpenEditConfirm,
    searchKey,
    limit,
    setLimit,
    order,
    orderBy,
    handleRequestSort,
    csvDownloadAction,
    cityId,
    setCityId,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    handleSearch,
    fromTopPageGroup,
    otherLanguages,
    setOtherLanguages,
    cashAllowed,
    setCashAllowed,
    isShopCanEditSetting,
    setIsShopCanEditSetting,
    shopDetail,
    setShopDetail,
    bulkEditStatusCheckedAll,
    setBulkEditStatusCheckedAll,
    bulkEditStatusCheckedList,
    setBulkEditStatusCheckedList,
    openBulkEditStatusModal,
    updateOpenBulkEditStatusModal,
    isFukuoka,
    editGochiKidFlagCheckedAll,
    setEditGochiKidFlagCheckedAll,
    gochiKidFlagEditCheckedList,
    setGochiKidFlagEditCheckedList,
    openGochiKidFlagEditModal,
    updateOpenGochiKidFlagEditModal,
    handleChangePage,
    bankCode,
    setBankCode,
    bankBranchCode,
    setBankBranchCode,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    registrationId,
    setRegistrationId,
    paymentGroupId,
    setPaymentGroupId,
    groupRegistrationId,
    setGroupRegistrationId,
    groupDisplayLimit,
    groupPaymentGroupType,
    educateSystem,
    allowGapPayment,
    setAllowGapPayment,
    gochiKidShopApplyType,
    anchorEl,
    setAnchorEl
  }) => {
    const open = Boolean(anchorEl);
    const idPopover = open ? 'info-popover' : undefined;
    const detail = {
      groupId,
      groupName,
      groupDepositManage,
      shopId,
      shopName,
      shopNameKana,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      // cityName,
      // cityId,
      address,
      address1,
      address2,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      tagStr,
      images,
      shopAnniversaries,
      status,
      statusStr,
      stealthMode,
      stealthModeStr,
      gochiRestriction,
      gochiRestrictionStr,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      inviteUserId,
      inviteUserStr,
      cognitoUserId,
      email,
      bankSwitchable,
      createdAt,
      updatedAt,
      shopCategories,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      accountStatus,
      paymentGroupType,
      otherLanguages,
      cashAllowed,
      shopDetail,
      isShopCanEditSetting,
      bankCode,
      bankBranchCode,
      registrationId,
      groupRegistrationId,
      paymentGroupId,
      allowGapPayment
    };
    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setGroupDepositManage(detailData.payload.groupDepositManage);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setShopNameKana(detailData.payload.shopNameKana);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        // setCityId(detailData.payload.cityId);
        // setCityName(detailData.payload.cityName);
        setAddress(detailData.payload.address);
        setAddress1(detailData.payload.address1);
        setAddress2(detailData.payload.address2);
        setBuilding(detailData.payload.building);
        setCashAllowed(detailData.payload.cashAllowed);
        setAllowGapPayment(detailData.payload.allowGapPayment);
        setShopDetail(detailData.payload.shopDetail);
        setIsShopCanEditSetting(detailData.payload.isShopCanEditSetting);
        setShopGroupName(detailData.payload.shopGroupName);
        setShopContactName(detailData.payload.shopContactName);
        setDepartment(detailData.payload.department);
        setContactPhone(detailData.payload.contactPhone);
        setPhone(detailData.payload.phone);
        setIntroduction(detailData.payload.introduction);
        setBusinessHours(detailData.payload.businessHours);
        setHoliday(detailData.payload.holiday);
        setNearestStation(detailData.payload.nearestStation);
        setPriceRange(detailData.payload.priceRange);
        setAccess(detailData.payload.access);
        setWebPage(detailData.payload.webPage);
        setShopCategoryId(detailData.payload.shopCategoryId);
        setNumberSit(detailData.payload.numberSit);
        setSmoking(detailData.payload.smoking);
        setParking(detailData.payload.parking);
        setSnsFacebook(detailData.payload.snsFacebook);
        setSnsTwitter(detailData.payload.snsTwitter);
        setSnsInstagram(detailData.payload.snsInstagram);
        setShowPhone(detailData.payload.showPhone);
        setChildShopFlag(detailData.payload.childShopFlag);
        setAccountStatus(detailData.payload.accountStatus);
        setPaymentGroupType(detailData.payload.paymentGroupType);
        if (
          typeof detailData.payload.tags !== 'undefined' &&
          detailData.payload.tags !== null
        ) {
          setTags(detailData.payload.tags);
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        }
        if (
          typeof detailData.payload.images !== 'undefined' &&
          detailData.payload.images !== null
        ) {
          setImages(detailData.payload.images);
        }
        if (
          typeof detailData.payload.shopAnniversaries !== 'undefined' &&
          detailData.payload.shopAnniversaries !== null
        ) {
          setShopAnniversaries(detailData.payload.shopAnniversaries);
        }
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setStealthMode(detailData.payload.stealthMode);
        setStealthModeStr(detailData.payload.stealthModeStr);
        setGochiRestriction(detailData.payload.gochiRestriction);
        setGochiRestrictionStr(detailData.payload.gochiRestrictionStr);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankCode(detailData.payload.bankAccount.bankCode);
          setBankBranchCode(detailData.payload.bankAccount.bankBranchCode);
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
        setInviteUserId(detailData.payload.inviteUserId);
        setInviteUserStr(detailData.payload.inviteUserStr);
        setCognitoUserId(detailData.payload.cognitoUserId);
        setEmail(detailData.payload.email);
        setBankSwitchable(detailData.payload.bankSwitchable);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
        setRegistrationId(detailData.payload.registrationId);
        setGroupRegistrationId(detailData.payload.groupRegistrationId);
        setPaymentGroupId(detailData.payload.paymentGroupId);
      });
    };

    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShop(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = async id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      await getShop(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const registerOpenAction = () => updateOpenShopAdd(true);
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);

    useEffect(() => {
      setBulkEditStatusCheckedAll(false);
      setBulkEditStatusCheckedList([]);
      setEditGochiKidFlagCheckedAll(false);
      setGochiKidFlagEditCheckedList([]);
    }, [filterParams]);

    const bulkEditShopStatusAction = async newStatus => {
      const result = {
        code: 500,
        message: 'エラーが発生しました！'
      };
      try {
        const response = await actions.editGroupShopStatus(groupId, {
          // ...filterParams,
          // processForAllShop: bulkEditStatusCheckedAll ? 1 : 0,
          processForAllShop: 0,
          shopIds: bulkEditStatusCheckedList,
          status: newStatus
        });
        if (response.type === EDIT_GROUP_SHOP_STATUS_SUCCESS) {
          result.code = response.payload.code;
          result.message = response.payload.message;
        }
      } catch (err) {
        console.log(err);
      }
      return result;
    };

    const gochiKidFlagEditShopAction = async (
      newGochiKidFlag,
      newGochiKidQrFlag
    ) => {
      const response = await actions.editGroupGochiKidFlagShop(groupId, {
        gochiKidFlag: newGochiKidFlag,
        gochiKidQrFlag: newGochiKidQrFlag,
        // processForAllShop: editGochiKidFlagCheckedAll ? 1 : 0,
        // processForAllShop: 0,
        shopIds: gochiKidFlagEditCheckedList
        // ...filterParams
      });
      if (response.type === EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS) {
        setEditGochiKidFlagCheckedAll(false);
        setGochiKidFlagEditCheckedList([]);
        await handleChangePage(page, filterParams);
      }
      return response;
    };

    const handleClickPopover = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
      setAnchorEl(null);
    };

    return (
      <div className={classes.shopTable}>
        {!fromTopPageGroup && (
          <div className={classes.tableHeader}>
            <ExPaginationGroup
              count={
                shops.totalCount % shops.limit > 0
                  ? Math.floor(shops.totalCount / shops.limit) + 1
                  : Math.floor(shops.totalCount / shops.limit)
              }
              selectedPage={page}
              handleChangePage={(event, pageNumber) => onChangePage(pageNumber)}
              limit={limit}
              setLimit={setLimit}
              totalCount={shops.totalCount}
              hideRowsPerPage
            />
            <div className={classes.buttonContainer}>
              <DownloadShopCsvButton
                onClickAction={() => csvDownloadAction()}
              />
              {!isFukuoka && (
                <>
                  <AddShopButton
                    onClickAction={registerOpenAction}
                    disabled={gochiKidShopApplyType === shopApplyType.CITY}
                  />
                  {gochiKidShopApplyType === shopApplyType.CITY && (
                    <div>
                      <IconButton
                        aria-describedby={idPopover}
                        className={classes.buttonInfo}
                        onClick={handleClickPopover}
                      >
                        <InfoIcon color="primary" />
                      </IconButton>
                      <Popover
                        id={idPopover}
                        open={open}
                        anchorEl={anchorEl}
                        classes={{
                          paper: classes.popoverContent
                        }}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center'
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                      >
                        <div className={classes.contentPopover}>
                          当グループアカウントでは、GOCHIプラットフォーム管理システムに登録されている店舗の住所（都道府県、市区町村）に基づいて、「こどもごちめし」をご利用いただける店舗が自動的に選ばれる設定となっております。
                          <br />
                          そのため、お客様ご自身で特定の店舗を追加することはできませんので、ご了承ください。
                        </div>
                      </Popover>
                    </div>
                  )}
                  <BulkEditShopStatusButton
                    disabled={
                      !bulkEditStatusCheckedAll &&
                      bulkEditStatusCheckedList.length === 0
                    }
                    onClickAction={() => {
                      console.log(
                        'bulkEditStatusCheckedList',
                        bulkEditStatusCheckedList
                      );
                      updateOpenBulkEditStatusModal(true);
                    }}
                  />
                  <GochiKidFlagEditShopButton
                    disabled={
                      !editGochiKidFlagCheckedAll &&
                      gochiKidFlagEditCheckedList.length === 0
                    }
                    onClickAction={() => {
                      console.log(
                        'gochiKidFlagEditCheckedList',
                        gochiKidFlagEditCheckedList
                      );
                      updateOpenGochiKidFlagEditModal(true);
                    }}
                  />
                </>
              )}
            </div>
          </div>
        )}

        <Table stickyHeader className={classes.shopTable}>
          <ShopTableHeadGroup
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            roles={roles}
            showCheckboxEditStatus={!fromTopPageGroup}
            bulkEditStatusCheckedAll={bulkEditStatusCheckedAll}
            setBulkEditStatusCheckedAll={setBulkEditStatusCheckedAll}
            bulkEditStatusCheckedList={bulkEditStatusCheckedList}
            setBulkEditStatusCheckedList={setBulkEditStatusCheckedList}
            isFukuoka={isFukuoka}
            editGochiKidFlagCheckedAll={editGochiKidFlagCheckedAll}
            setEditGochiKidFlagCheckedAll={setEditGochiKidFlagCheckedAll}
            gochiKidFlagEditCheckedList={gochiKidFlagEditCheckedList}
            setGochiKidFlagEditCheckedList={setGochiKidFlagEditCheckedList}
          />
          <ShopTableBodyGroup
            detailOpenAction={detailOpenAction}
            editOpenAction={editOpenAction}
            order={order}
            orderBy={orderBy}
            showCheckboxEditStatus={!fromTopPageGroup}
            bulkEditStatusCheckedList={bulkEditStatusCheckedList}
            setBulkEditStatusCheckedList={setBulkEditStatusCheckedList}
            setBulkEditStatusCheckedAll={setBulkEditStatusCheckedAll}
            isFukuoka={isFukuoka}
            setEditGochiKidFlagCheckedAll={setEditGochiKidFlagCheckedAll}
            gochiKidFlagEditCheckedList={gochiKidFlagEditCheckedList}
            setGochiKidFlagEditCheckedList={setGochiKidFlagEditCheckedList}
          />
        </Table>
        {!fromTopPageGroup && (
          <ExPaginationGroup
            count={
              shops.totalCount % shops.limit > 0
                ? Math.floor(shops.totalCount / shops.limit) + 1
                : Math.floor(shops.totalCount / shops.limit)
            }
            selectedPage={page}
            handleChangePage={(event, pageNumber) => onChangePage(pageNumber)}
            limit={limit}
            setLimit={setLimit}
            totalCount={shops.totalCount}
            hideRowsPerPage
          />
        )}

        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modal}
        >
          <ShopDetailGroup
            updateOpenDetailModal={updateOpenDetailModal}
            detail={detail}
            roles={roles}
            isFukuoka={isFukuoka}
            groupDisplayLimit={groupDisplayLimit}
          />
        </Modal>

        <Modal
          open={openShopAdd}
          onClose={() => {
            updateOpenShopAdd(false);
          }}
        >
          <ShopAddGroup
            openShopAddConfirm={openShopAddConfirm}
            updateOpenShopAdd={updateOpenShopAdd}
            updateOpenShopAddConfirm={updateOpenShopAddConfirm}
            groupDepositManage={depositManage}
            paymentGroupType={groupPaymentGroupType}
            cancelAction={shopCancelAction}
            backAction={shopBackAction}
            searchKey={{ groupId }}
            groupShop
            roles={roles}
            cityId={cityId}
            setCityId={setCityId}
            onAddSuccess={handleSearch}
          />
        </Modal>

        <Modal
          open={openEditModal}
          onClose={() => {
            updateOpenEditModal(false);
          }}
          className={classes.modal}
        >
          <ShopEditGroup
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            roles={roles}
            editInput={detail}
            searchKey={searchKey}
            onEditSuccess={handleSearch}
            isFukuoka={isFukuoka}
            listBank={listBank}
            listBankBranch={listBankBranch}
            groupDisplayLimit={groupDisplayLimit}
            educateSystem={educateSystem}
          />
        </Modal>

        <BulkEditShopStatusModal
          open={openBulkEditStatusModal}
          onClose={() => {
            updateOpenBulkEditStatusModal(false);
          }}
          bulkEditAction={bulkEditShopStatusAction}
          onEditSuccess={() => onChangePage(1)}
        />

        <GochiKidFlagEditShopModal
          open={openGochiKidFlagEditModal}
          onClose={() => {
            updateOpenGochiKidFlagEditModal(false);
          }}
          gochiKidFlagEditCheckedList={gochiKidFlagEditCheckedList}
          gochiKidFlagEditShopAction={gochiKidFlagEditShopAction}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
